import { defineMessages } from 'react-intl';

/** Trial-recap variant copy for the Clinician upgrade modal (react-intl; not in common.json). */
export const clinicianUpgradeRecapMessages = defineMessages({
  title: {
    defaultMessage:
      '{daysLeft, plural, one {# day} other {# days}} of complimentary Clinician access remaining',
    id: 'zEHjuARR4S',
    description:
      'Trial-recap Clinician upgrade modal heading; days remaining on complimentary Clinician access',
  },
  subtitle: {
    defaultMessage:
      "Do nothing and you'll return to <link>Scribe Plus</link>, (formerly Heidi Pro). No billing changes.",
    id: 'CqDQ3uTVUC',
    description:
      "Subtitle under the trial-recap Clinician upgrade modal: downgrade outcome; 'Scribe Plus' links to the plan-changes help article",
  },
  upgradingTitle: {
    defaultMessage: "You're upgrading to Clinician",
    id: 'aekO9NZ7j7',
    description:
      'Heading on the Clinician upgrade modal when opened from the post-90-day trial-ended recap',
  },
  titleNinetyDayTrialEnded: {
    defaultMessage: "Care that's backed by evidence, in every consult",
    id: 'sV3RXRz6KH',
    description:
      'Heading on the Clinician upgrade modal for users whose 90-day reverse trial has ended',
  },
  subtitleNinetyDayTrialEnded: {
    defaultMessage: 'Live clinical answers from sources you trust.',
    id: 'ULW5SE6pM+',
    description:
      'Subtitle on the Clinician upgrade modal for users whose 90-day reverse trial has ended',
  },
});
